<template>
  <div class="search-form padding_large">
    <form @submit.prevent="doSearch">
      <div class="input-holder">
        <StyledIcon iconsColor="#fff" class="icon" v-html="svgIcons.loupe" />
        <input
          ref="input"
          name="search"
          v-model="inputValue"
          :placeholder="placeholder"
          class="input-with-icon"
          type="text"
        />
        <!-- hidden mirror of the typed text, used to measure its width -->
        <span ref="mirror" class="text-mirror" aria-hidden="true"></span>
        <button
          ref="clear"
          v-show="inputValue"
          type="button"
          class="clear-search"
          :style="clearLeft !== null ? { left: clearLeft + 'px' } : null"
          aria-label="Tøm søket"
          @click="inputValue = ''"
        >
          &times;
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import StyledIcon from "@/components/elements/StyledIcon";

export default {
  name: "search-form",
  props: {
    placeholder: String,
    // false for the menu field: archive searches use the same ?search=
    // param, so it must not mirror it, and it empties itself once the term
    // is handed to the search page (whose own field then shows it)
    bindToRoute: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const VM = this;
    return {
      inputValue:
        VM.bindToRoute && VM.$route.query.search ? VM.$route.query.search : "",
      // left offset (px) of the clear button so it sits right after the text
      clearLeft: null
    };
  },
  watch: {
    inputValue(val) {
      this.$emit("changed", val);
      this.$nextTick(this.positionClear);
    },
    // keep the visible input in sync when the query changes from outside
    // (back button, programmatic navigation)
    "$route.query.search"(val) {
      if (!this.bindToRoute) return;
      const value = val || "";
      if (value !== this.inputValue) this.inputValue = value;
    }
  },
  computed: {},
  components: {
    StyledIcon
  },
  mounted() {
    if (this.inputValue) {
      this.$emit("changed", this.inputValue);
    }
    this.$nextTick(this.positionClear);
    window.addEventListener("resize", this.positionClear);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.positionClear);
  },
  methods: {
    doSearch(e) {
      this.$emit("submit", this.inputValue);
      if (!this.bindToRoute) this.inputValue = "";
    },
    // Place the clear "X" directly after the typed text. When the text is
    // wider than the field, pin the button to the right edge instead.
    positionClear() {
      const input = this.$refs.input;
      const mirror = this.$refs.mirror;
      if (!input || !mirror || !this.inputValue) {
        this.clearLeft = null;
        return;
      }
      const cs = window.getComputedStyle(input);
      mirror.style.fontFamily = cs.fontFamily;
      mirror.style.fontSize = cs.fontSize;
      mirror.style.fontWeight = cs.fontWeight;
      mirror.style.letterSpacing = cs.letterSpacing;
      mirror.textContent = this.inputValue;

      const textWidth = mirror.offsetWidth;
      const padLeft = parseFloat(cs.paddingLeft) || 0;
      const padRight = parseFloat(cs.paddingRight) || 0;
      const borderLeft = parseFloat(cs.borderLeftWidth) || 0;
      const btn = this.$refs.clear;
      const btnWidth = btn && btn.offsetWidth ? btn.offsetWidth : 36;

      const afterText = borderLeft + padLeft + textWidth + 4;
      const maxLeft = borderLeft + input.clientWidth - padRight - btnWidth + 8;
      this.clearLeft = Math.round(Math.min(afterText, maxLeft));
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.search-form {
  background-color: $purple;
  .input-holder {
    position: relative;
    .icon {
      position: absolute;
      top: 50%;
      margin-top: 2px;
      transform: translateY(-50%);
      left: 10px;
    }
    .input-with-icon {
      border: 2px solid #fff;
      color: #fff;
      background-color: $purple;
      box-shadow: none;
      width: 100%;
      font-size: 16px;
      padding: 8px 35px;
      &::placeholder {
        color: #fff;
      }
    }
    .input-with-icon {
      padding-right: 45px;
    }
    .text-mirror {
      position: absolute;
      top: 0;
      left: 0;
      visibility: hidden;
      pointer-events: none;
      white-space: pre;
    }
    .clear-search {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 6px; // fallback until positionClear() has measured the text
      appearance: none;
      -webkit-appearance: none;
      background: transparent;
      border: 0;
      border-radius: 50%;
      color: #fff;
      font-size: 30px;
      line-height: 1;
      width: 36px;
      height: 36px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &:hover,
      &:focus {
        background-color: rgba(255, 255, 255, 0.2);
        outline: none;
      }
    }
  }
}
</style>
